import { axiosAjax } from '@app/src/config/axios';
import { isClientEnv } from '@app/src/utils/validations';

export const passwordService = {
  async postForgot(json: any): Promise<any> {
    const appStorage = isClientEnv() && JSON.parse(localStorage.getItem('app'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${appStorage && appStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.post(process.env.API_PASSWORD_FORGOT, json, config);
      return data;
    } catch (e) {
      throw new Error(e);
    }
  },
  async postReset(json: any): Promise<any> {
    const appStorage = isClientEnv() && JSON.parse(localStorage.getItem('app'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${appStorage && appStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.post(process.env.API_PASSWORD_RESET, json, config);
      return data;
    } catch (e) {
      throw new Error(e);
    }
	}
};
